import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TreeItemType, MtlFolders } from './camtl.config';
import { CgpTreeviewService } from '../../shared/cgp-treeview/cgp-treeview.service';
import { TreeItem } from '../../shared/cgp-treeview/cgp-tree-item';
import { ToolChildrenService, ToolService } from './camtl.service';
import { SystemSelectService } from './system-select/system-select.service';
import { AuthenticationService } from '../../auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'camtl',
  templateUrl: './camtl.component.html',
  // styleUrls: ['./camtl.component.scss'],
  host: { 'class': 'router-outlet' },
})
export class CamtlComponent implements OnInit, OnDestroy {
  dataSource: any;
  selectedItem: any;
  root: TreeItem;
  version: string = '2.0.0';
  @Input()
  system: any;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  constructor(
    public router: Router,
    public authService: AuthenticationService,
    private cgpTreeviewService: CgpTreeviewService,
    private toolService: ToolService,
    private toolChildrenService: ToolChildrenService,
    private systemSelectService: SystemSelectService,
  ) { }


  ngOnInit() {
    if (!this.system) {
      this.systemSelectService.system$
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((system) => {
          if (this.system === system && this.selectedItem) return;
          this.system = system;
          system ? this.querySystemLayout(system) : this.root = null;
        });

      this.cgpTreeviewService.selected$
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(selected => {
          this.selectedItem = selected
          if (selected && selected.isChanged) {
            selected.isChanged = false;
            this.updateChildren(selected);
          }
        });

      this.cgpTreeviewService.dataSource$
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(dataSource => this.dataSource = dataSource);

      this.toolService
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          if (
            this.isShowDetailView() &&
            data && data.length > 0 &&
            data[0].Title &&
            data[0].HierarchicalDetailsType
          ) {
            this.initializeTree(data);
          }
        })

      this.systemSelectService.get();
      this.cgpTreeviewService.get();
      this.cgpTreeviewService.getSelected();
    }
    else {
      this.querySystemLayout(this.system);
    }

  }

  ngOnChanges() {
    this.systemSelectService.system$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((system) => {
        if (this.system === system && this.selectedItem) return;
        this.system = system;
        system ? this.querySystemLayout(system) : this.root = null;
      });

    this.cgpTreeviewService.selected$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(selected => {
        this.selectedItem = selected
        if (selected && selected.isChanged) {
          selected.isChanged = false;
          this.updateChildren(selected);
        }
      });

    this.cgpTreeviewService.dataSource$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(dataSource => this.dataSource = dataSource);

    this.toolService
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if (
          this.isShowDetailView() &&
          data && data.length > 0 &&
          data[0].Title &&
          data[0].HierarchicalDetailsType
        ) {
          this.initializeTree(data);
        }
      })

    this.systemSelectService.get();
    this.cgpTreeviewService.get();
    this.cgpTreeviewService.getSelected();
  }


  querySystemLayout(system) {
    if (!this.isShowDetailView()) return;
    this.toolService.read('/systemlayoutinfo/' + system.Id, true)
  }


  initializeTree(data) {
    this.root = new TreeItem();
    let treeviewData: any[] = data
      .map(dataItem => {
        dataItem.id = { index: dataItem.Id };
        dataItem.title = dataItem.Title;
        delete dataItem.Id;
        delete dataItem.Title;
        this.setCategories(dataItem);
        return dataItem;
      })

    this.cgpTreeviewService.add(treeviewData);
  }


  compare(check, item): boolean {
    let isParentsValid = item.parent === check.parent;
    if (item.parent && check.parent) {
      isParentsValid = item.parent.id.index === check.parent.id.index;
    }
    return item.index === check.index && isParentsValid;
  }


  /**
   * Recursivly search through the dataItems for the item that matches the provided id
   * @param id - check value
   * @param dataItems - list of items from dataSource to compare against
   */

  getDataItem(check, dataItems, depth): any {
    let match: any = undefined;
    dataItems.some(item => {
      if (this.compare(check, item.id)) {
        match = item;
        return true;
      } else if (item.children && depth < 7) {
        let result = this.getDataItem(check, item.children, depth + 1);
        if (result) {
          match = result;
          return true;
        }
      }
    })

    return match;
  }



  /**
   * Query the service and set the children for the selected item
   * @param dataItem - selected treeItem
   */
  queryChildItems(dataItem: any) {
    let _id = dataItem.id.index;
    this.toolChildrenService.read2('/' + _id, true)
      .then(response => {
        response.map(item => {
          item.id = {
            parent: dataItem,
            index: item.Id,
            title: item.Title,
            type: item.HierarchicalDetailsType,
          };
          item.title = item.Title;
          delete item.Id
          delete item.Title
        });

        dataItem.children = response;
        this.setCategories(dataItem);
      });
  }


  /**
   * This method sets the category folders for the provided dataItem and sorts the dataItem's 
   * children into their respective category
   * @param dataItem 
   */
  setCategories(dataItem) {
    if (dataItem.HierarchicalDetailsType === 'Kit' || dataItem.HierarchicalDetailsType === 'Tool') return;

    if (dataItem.children) {
      let immediateChildren = dataItem.children
        .filter(child => child.HierarchicalDetailsType === dataItem.HierarchicalDetailsType);
    }

    try {
      let list: Array<any> = JSON.parse(JSON.stringify(MtlFolders[dataItem.HierarchicalDetailsType]));
      list.map(folder => {
        folder.id = {
          parent: dataItem,
          index: folder.HierarchicalDetailsType,
        };

        if (dataItem.children) {
          folder.children = dataItem.children
            .filter(child => child.HierarchicalDetailsType === folder.HierarchicalDetailsType);
        }
        return folder;
      })


      let arr: any[] = [];
      list.forEach(x => arr.push(Object.assign({}, x)))
      dataItem.children = arr;

    } catch (e) {
      console.error("There was an error mapping folders to dataItem", dataItem, e.name, e.message);
    }


  }


  /**
   * Recursively Update the children for the treeview item
   * If the item has children, then go through the query, else
   * @param dataItem - treeview item
   */
  updateChildren(dataItem) {
    if (dataItem.HasChildren) {
      this.queryChildItems(dataItem);
    } else if (dataItem.children) {
      dataItem.children.forEach(child => this.updateChildren(child));
    }
    else {
      this.setCategories(dataItem);
    }
  }


  /**
   * Update the dataSource to match the state of the panelbar (expanded|selected)
   * Update the children for the selected dataItem
   * @param dataItems 
   */
  onFocus(dataItems: any[]) {
    dataItems.forEach(item => {
      let dataItem = this.getDataItem(item.id, this.dataSource, 1);
      if (dataItem) {
        dataItem.expanded = item.expanded;
        dataItem.selected = item.selected;
        if (dataItem.selected) {
          this.cgpTreeviewService.setSelected(dataItem);
          this.updateChildren(dataItem);
          this.stateChange(dataItem);
        }
      }
    });
  }


  getRoute(dataItem): string {
    let route: string;
    switch (dataItem.HierarchicalDetailsType) {
      case TreeItemType.CELL:
        route = "Cells";
        break;
      case TreeItemType.STATION:
        route = "Stations";
        break;
      case TreeItemType.TOOL:
        route = "Tools";
        break;
      case TreeItemType.KIT:
        route = "Kits";
        break;
      default:
        route = "SystemLayout"
        break;
    }
    return route;
  }


  stateChange(dataItem) {
    let route = this.getRoute(dataItem),
      _parentId = dataItem.id.parent ? dataItem.id.parent.id.index : undefined,
      _params: any = { queryParams: { ParentId: _parentId } },
      _routeId: string = dataItem.id.index.indexOf("-") !== -1 ?
        '/' + dataItem.id.index : '',
      _path = "/MESC/CAMTL/MasterToolList/Detail/" + route + _routeId;
    this.router.navigate([_path], _params);
  }


  isShowSystemSelect(): boolean {
    let ss: string = this.router.url;
    return ss.includes('/MasterToolList/Configuration') ||
      ss.includes('/MasterToolList/Detail') ||
      ss.includes('/TimingCharts') ||
      ss.includes('/MasterToolList/List') ||
      ss.includes('/Contacts');
    //|| ss.includes('/Administration/Reports');
  }


  isShowDetailView(): boolean {
    let ss: string = this.router.url;
    let result = ss.includes('MasterToolList/Detail');
    return result;
  }


}
